import { render, staticRenderFns } from "./carousel-section.vue?vue&type=template&id=5b584e9a&scoped=true&"
import script from "./carousel-section.vue?vue&type=script&lang=js&"
export * from "./carousel-section.vue?vue&type=script&lang=js&"
import style0 from "./carousel-section.vue?vue&type=style&index=0&id=5b584e9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b584e9a",
  null
  
)

export default component.exports